<template>
  <div class="svg-container" data-testid="spine-container">
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 87 577" style="enable-background:new 0 0 87 577;" xml:space="preserve"
    >
      <spine-segment
        v-for="segment of vertebrae"
        :key="segment.key"
        :segment="segment"
        :selected="isSelected(segment.key)"
        @mouseover="segmentMouseOver"
        @mouseout="segmentMouseOut"
        @click="segmentClick"
      />
    </svg>
    <div
      v-show="state.hoverSegment"
      ref="tooltip"
      class="md-tooltip spine-tooltip"
      data-testid="spine-segment-hover-tooltip"
      :class="state.hoverSegment"
    >
      Segment
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import vertebrae from '../../../../lib/common/config/vertebrae';
import SpineSegment from './SpineSegment';

export default {
  name: 'case-spine-assessment',
  components: {
    SpineSegment,
  },
  props: {
    spinalAssessments: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      vertebrae,
      state: {
        spinalAssessments: null,
        hoverSegment: null,
      }
    }
  },
  created() {
    this.state.spinalAssessments = cloneDeep(this.spinalAssessments) || [];
  },
  methods: {
    isSelected(segmentKey) {
      return !!this.state.spinalAssessments.find(sa => sa.key === segmentKey);
    },
    segmentMouseOver(segmentKey) {
      this.state.hoverSegment = segmentKey;
      this.$refs.tooltip.style.left = '-70px';
      const info = this.vertebrae.find(seg => seg.key == segmentKey);
      if (info) {
        this.$refs.tooltip.innerHTML = info.label.en;
        this.$refs.tooltip.style.top = info.tooltipTop;
      }
    },
    segmentMouseOut() {
      this.state.hoverSegment = null;
    },
    segmentClick(segmentKey) {
      if (this.readonly) {
        return;
      }
      if (this.state.spinalAssessments.find(sa => sa.key === segmentKey)) {
        this.state.spinalAssessments = this.state.spinalAssessments.filter(sa => sa.key !== segmentKey)
      } else {
        this.state.spinalAssessments = this.state.spinalAssessments.concat({ key: segmentKey });
      }
      this.$emit('update', this.state.spinalAssessments);
    },
  }
};
</script>

<style scoped>
.svg-container {
  height: 100%;
  position: relative;
}
svg {
  height: 100%;
}

.spine-tooltip {
  position: absolute;
  top: 20px;
  left: 40px;
}

.spine-tooltip::after {
  content: " ";
  position: absolute;
  top: 50%;
  left: 100%; /* To the right of the tooltip */
  margin-top: -1px;
  border: 1px solid #000000;
  width: 35px;
}

.spine-tooltip.C1::after {
  width: 50px;
}
.spine-tooltip.C2::after {
  width: 50px;
}
.spine-tooltip.C3::after {
  width: 50px;
}
.spine-tooltip.C4::after {
  width: 50px;
}
.spine-tooltip.C5::after {
  width: 50px;
}
.spine-tooltip.C6::after {
  width: 50px;
}
.spine-tooltip.C7::after {
  width: 60px;
}
.spine-tooltip.T1::after {
  width: 60px;
}
.spine-tooltip.T1::after {
  width: 60px;
}
.spine-tooltip.T2::after {
  width: 63px;
}
.spine-tooltip.T3::after {
  width: 66px;
}
.spine-tooltip.T4::after {
  width: 68px;
}
.spine-tooltip.T5::after {
  width: 70px;
}
.spine-tooltip.T6::after {
  width: 70px;
}
.spine-tooltip.T7::after {
  width: 70px;
}
.spine-tooltip.T8::after {
  width: 68px;
}
.spine-tooltip.T9::after {
  width: 66px;
}
.spine-tooltip.T10::after {
  width: 54px;
}
.spine-tooltip.T11::after {
  width: 47px;
}
.spine-tooltip.T12::after {
  width: 42px;
}
.spine-tooltip.L1::after {
  width: 49px;
}
.spine-tooltip.L2::after {
  width: 44px;
}
.spine-tooltip.L3::after {
  width: 42px;
}
.spine-tooltip.L4::after {
  width: 42px;
}
.spine-tooltip.L5::after {
  width: 42px;
}
.spine-tooltip.SACRUM::after {
  width: 30px;
}
.spine-tooltip.COCCYX::after {
  width: 70px;
}
</style>
